// Select elements
const mobileMenuOpen = document.querySelector(".header__icon--menu");
const mobileMenuClose = document.querySelector(".mM_h_close");
const mobileMenuMain = document.querySelector(".mobileMenu_main");
const mobileMenuIn = document.querySelector(".mobileMenu_in");
const mMListItems = document.querySelectorAll(".mobileMenu_LI_JS");
const backContainer = document.querySelector(".mobileMenu_back_con");
const backButton = document.querySelector(".mobileMenu_back");
const backButtonNested = document.querySelector(".mobileMenu_back_B");
const allChilds = document.querySelectorAll(".mobileMenu_childUL_JS");

// Open mobile menu
mobileMenuOpen.addEventListener("click", () => {
  mobileMenuMain.style.display = "flex";
  document.body.style.overflow = "hidden";
  setTimeout(() => {
    mobileMenuIn.classList.add("header_blur_main_js");
    const mobileMenuHead = document.querySelector(".mobileMenu_head");
    const mobileMenuBody = document.querySelector(".mobileMenu_body");

    mobileMenuHead.style.visibility = "visible";
    mobileMenuHead.style.opacity = "1";
    mobileMenuBody.style.visibility = "visible";
    mobileMenuBody.style.opacity = "1";
  }, 10);
});

// Close mobile menu
mobileMenuClose.addEventListener("click", () => {
  mobileMenuIn.classList.remove("header_blur_main_js");
  const mobileMenuHead = document.querySelector(".mobileMenu_head");
  const mobileMenuBody = document.querySelector(".mobileMenu_body");

  mobileMenuHead.style.visibility = "hidden";
  mobileMenuHead.style.opacity = "0";
  mobileMenuBody.style.visibility = "hidden";
  mobileMenuBody.style.opacity = "0";

  document.body.style.overflow = "auto";
  setTimeout(() => {
    mobileMenuMain.style.display = "none";
  }, 250);
});

// Handle list items with nested submenus
mMListItems.forEach((item) => {
  // Check if the item has child elements (submenu)
  if (item.childElementCount > 1) {
    const toggleIcon = item.querySelector("svg");
    
    toggleIcon.addEventListener("click", () => {
      item.parentElement.style.left = "-100%"; // Slide out the current menu
      const childMenu = item.lastElementChild;
      childMenu.style.visibility = "visible";
      childMenu.style.opacity = "1";
      
      backContainer.style.display = "flex";
      backButton.style.display = "flex";

      // Handle nested submenus
      const nestedItems = childMenu.children;
      Array.from(nestedItems).forEach((nestedItem) => {
        if (nestedItem.childElementCount > 1) { // Check if the nested item has further submenus
          const nestedToggleIcon = nestedItem.querySelector("svg");
          nestedToggleIcon.addEventListener("click", () => {
            nestedItem.parentElement.style.left = "0"; // Slide in the nested menu
            const nestedChildMenu = nestedItem.lastElementChild;
            nestedChildMenu.style.visibility = "visible";
            nestedChildMenu.style.opacity = "1";

            backButtonNested.style.display = "flex";
          });
        }
      });
    });
  }
});

// Back button for the first level
backButton.addEventListener("click", () => {
  mMListItems.forEach((item) => {
    item.parentElement.style.left = "0"; // Slide back to the main menu
  });
  allChilds.forEach((nestedChildMenu) => {
    nestedChildMenu.style.visibility = "hidden";
    nestedChildMenu.style.opacity = "0";
  });
  backContainer.style.display = "none";
  backButton.style.display = "none";
});

// Back button for nested submenus
backButtonNested.addEventListener("click", () => {
  mMListItems.forEach((item) => {
    const nestedItems = item.lastElementChild ? item.lastElementChild.children : [];
    Array.from(nestedItems).forEach((nestedItem) => {
      nestedItem.parentElement.style.left = "100%"; // Slide out the nested menu
      const nestedChildMenu = nestedItem.lastElementChild;
      if (nestedChildMenu) {
        nestedChildMenu.style.visibility = "hidden";
        nestedChildMenu.style.opacity = "0";
      }
    });
  });
  backButtonNested.style.display = "none";
});
